import axios from '@/axios'

const PER_PAGE = 100


export function getUserFromGithub() {
  const url = '/api/github/call'
  const data = {
    obj: "users", fun: "get", arg: {}
  }
  return axios.post(url, data)
}

export function checkAdmin() {
  const url = '/isAdmin'
  return axios.get(url)
}

export function getReposFromGithub() {
  const url = '/api/github/call'
  let data = {
    arg:{per_page: PER_PAGE, affiliation: "owner,organization_member"},
    affiliation:"owner,organization_member",
    per_page:100,
    fun:"getAll",
    obj:"repos"
  }
  return new Promise((resolve, reject) =>{
    axios.post(url, data).then((res) =>{
      //处理下一页数据的函数待定
        resolve(res)
    })
  })
}

export function getLinkedReposFromGithub(set) {
  const url = '/api/repo/getAll'
  let data = {
   set:set
  }
  return new Promise((resolve, reject) =>{
    axios.post(url, data).then((res) =>{
      //处理下一页数据的函数待定
        resolve(res)
    })
  })
}

export function getDefaultClaFiles(user_token) {
    const url = '/static/cla-assistant.json'
    let header = {}
    header.Accept = 'application/vnd.github.moondragon+json'
    if (user_token) {
        header.Authorization = 'token ' + user_token;
    }

    return axios.get(url, { 'headers': header });
}

export function getAllGists() {
  const url = '/api/github/call'
  let data = {obj: "gists", fun: "getAll"}

  return new Promise((resolve, reject) =>{
    axios.post(url, data).then((res) =>{
      //处理下一页数据的函数待定
        res.data = res.data.value? res.data.value:res.data
        resolve(res)
    })
  })
}

export function createLinkedRepo(data) {
  const url = '/api/repo/create'
  return axios.post(url,data)
}

export function getGist(data) {
  const url = '/api/cla/getGist'
  return axios.post(url, data)
}

export function getWebhook(data) {
  const url = '/api/webhook/get'
  return axios.post(url, data)
}


export function validateRepoPr(data) {
  const url = '/api/cla/validatePullRequests'
  return axios.post(url, data)
}

export function getSignatures(data) {
  const url = '/api/cla/getAll'
  return axios.post(url, data)
}

export function updateRepoOrOrg(type, data) {
  const url = `/api/${type}/update`
  return axios.post(url, data)
}

export function RemoveRepoOrOrg(type, data) {
  const url = `/api/${type}/remove`
  return axios.post(url, data)
}

// export function downloadSignature(data) {
//   const url = `/exportAll?repoId=${data.repoId}&gist_url=${data.gist.gist_url}&gist_version=${data.gist.gist_version}`
//   return axios.post(url, data)
// }



// WEBPACK FOOTER //
// ./src/api/home.js